<template>
    <div class="fork-truck-info">
        <m-pane
            ref="tablePage"
            class="tablePage"
            :config="config"
            :totalData="tableData"
            :pageTotal="pageTotal"
            :loading="loading"
            pageID="forkTruckInfo"
            :currentPage="searchParams.pageNo"
            :fixedSeletionColumn="false"
            @selectChange="selectChange"
            @refresh-btn="handleRefresh"
            @add-btn="handleAdd"
            @deleteData-btn="handleDelete"
            @start-btn="handleStart"
            @stop-btn="handleStop"
            @preview-btn="handlePreview"
            @row-db-click="rowDBClick"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            >
        </m-pane>
        <add-fork-truck-dialog
            v-if="openAddForkTruckDialog"
            :openAddForkTruckDialog.sync="openAddForkTruckDialog"
            :title="title"
            :relationId="relationId"
            @success="successCallback"
            >
        </add-fork-truck-dialog>
        <attachmentDialog
            v-if='attachmentShow'
            :attachmentShow.sync='attachmentShow'
            :rowData='row'>
        </attachmentDialog>
    </div>
</template>
<script>
import mPane from '../../../../../../components/Table/Index.vue';
import config from './config.js';
import AddForkTruckDialog from './AddForkTruckDialog.vue';
import attachmentDialog from '../../../../../../components/AttachmentDialog';
import { getForkTruckInfo, deleteForkTruckInfo, startForkTruckInfo, stopForkTruckInfo } from '../../../../../../api/forkTruck';
import { dictWithUrl } from '@/components/lots/api';
import { mapState } from 'vuex';
export default {
    name: 'ForkTruckInfo',
    components: { mPane, AddForkTruckDialog, attachmentDialog },
    props: {
        supplierTab: {
            type: Object,
            default() {
                return {
                    supplierName: '',
                    propertyNature: ''
                };
            }
        },
        activeCode: {
            type: String,
            default() {
                return ''
            },
        },
        code: {
            type: String,
            default() {
                return ''
            },
        },
    },
    data() {
        return {
            tableData: [],
            config,
            pageTotal: 0,
            loading: false,
            searchParams: {
                pageSize: 10,
                pageNo: 1
            },
            openAddForkTruckDialog: false,
            attachmentShow: false,
            row: {},
            title: '叉车数据维护详情页面',
            dict: {},
            multipleSelection: [],
            relationId: ''
        };
    },
    computed: {
        ...mapState(['supplier'])
    },
    mounted() {
        dictWithUrl('SRM_DEVICE_TYPE_NAME,SRM_EQUIPMENT_BRAND').then(res => {
            this.dict = res.data;
            this.getTableData();
        });
    },
    methods: {
        getTableData() {
            const isSupplier = !!this.supplier;
            const params = {
                supplierCode: isSupplier ? this.supplier.supplierCode : this.$route.query.supplierCode,
                ...this.searchParams
            };
            getForkTruckInfo(params).then(res => {
                if (res && +res.code === 0) {
                    this.pageTotal = res.data.totalCount;
                    this.tableData = res.data.list;
                    this.tableData.forEach(item => {
                        item['newFlag'] = item['newFlag'] === 0 ? '是' : '否';
                        item['enableFlag'] = item['enableFlag'] === 0 ? '启用' : '停用';
                        item['deviceType'] = this.dict['SRM_DEVICE_TYPE_NAME'][item['deviceType']];
                        item['deviceBrand'] = this.dict['SRM_EQUIPMENT_BRAND'][item['deviceBrand']];
                    });
                }
            });
        },
        selectChange(array) { this.multipleSelection = array; },
        handleRefresh() { this.getTableData(); }, // 刷新
        handleAdd() { this.openAddForkTruckDialog = true; }, // 新增
        handleDelete() { // 删除
            if (this.multipleSelection.length === 0) {
                this.$message.warning('当前没有选中的数据');
            } else if (this.multipleSelection.length > 1) {
                this.$message.warning('当前只能操作一条数据！');
            } else if (this.multipleSelection[0]['enableFlag'] === '启用') {
                this.$message.warning('叉车信息启用状态，不允许删除');
            } else {
                this.$confirm('是否确定删除选择的数据？', '删除确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    const idData = [];
                    this.multipleSelection.forEach(item => idData.push(item.relationId));
                    deleteForkTruckInfo(JSON.stringify(idData)).then(res => {
                        if (res && res.code === '0') {
                            this.$message.success('删除成功');
                            this.getTableData();
                        }
                    });
                }).catch(() => {});
            }
        },
        handleStart() { // 启用
            if (this.multipleSelection.length === 0) {
                this.$message.warning('当前没有选中的数据');
            } else if (this.multipleSelection.length > 1) {
                this.$message.warning('当前只能操作一条数据！');
            } else if (this.multipleSelection[0].enableFlag === '启用') {
                this.$message.warning('该叉车已被启用');
            } else {
                this.$confirm('是否确定要启用选择的数据？', '启用确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    const idData = [];
                    this.multipleSelection.forEach(item => idData.push(item.relationId));
                    startForkTruckInfo(idData).then(res => {
                        if (res && res.code === '0') {
                            this.getTableData();
                            this.$message.success('已启用');
                        }
                    });
                });
            }
        },
        handleStop() { // 停用
            if (this.multipleSelection.length === 0) {
                this.$message.warning('当前没有选中的数据');
            } else if (this.multipleSelection.length > 1) {
                this.$message.warning('当前只能操作一条数据！');
            } else if (this.multipleSelection[0].enableFlag === '停用') {
                this.$message.warning('该叉车已被停用');
            } else {
                this.$confirm('是否确定要停用选择的数据？', '启用确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    const idData = [];
                    this.multipleSelection.forEach(item => idData.push(item.relationId));
                    stopForkTruckInfo(idData).then(res => {
                        if (res && res.code === '0') {
                            this.getTableData();
                            this.$message.success('已停用');
                        }
                    });
                });
            }
        },
        handlePreview(data) {},
        rowDBClick(row) { // 双击表格行
            this.relationId = row.relationId;
            this.openAddForkTruckDialog = true;
        },
        successCallback() { // 表单提交成功回调
            this.getTableData();
        },
        pageChange(data) {
            this.$emit('sensitive')
            this.searchParams.pageNo = data;
            this.getTableData();
        },
        sizeChange(data) {
            this.$emit('sensitive')
            this.$set(this.searchParams, 'pageSize', data);
            this.$set(this.searchParams, 'pageNo', 1);
            this.getTableData();
        }
    },
    watch: {
        activeCode(val) {
            if (val === this.code) {
                this.getTableData()
            }
        },
    },
};
</script>
